import { IProductNew } from '../interfaces/product';

interface IProductConfiguration {
  tooltip: string;
  label: string;
  property?: any;
}

export function productConfigurations(product: IProductNew): IProductConfiguration[] {
  return [
    {
      tooltip: 'Chat',
      label: 'Chat',
      property: product?.chat
    },
    {
      tooltip: 'Toast',
      label: 'Toast',
      property: product?.toast
    },
    {
      tooltip: 'Exit popup',
      label: 'Pop up',
      property: product?.exitPopUp
    },
    {
      tooltip: 'Tema personalizado',
      label: 'Tema',
      property: product?.theme
    },
    {
      tooltip: 'Confirmação de email',
      label: 'Email',
      property: product.config?.requestEmailConfirmation
    },
    {
      tooltip: 'Página de obrigado para Upsell',
      label: 'Upsell',
      property: product.config?.hasThankyouUpsell
    },
    {
      tooltip: 'Back Redirect',
      label: 'Back Redirect',
      property: product.config?.backRedirect
    }
  ];
}
